import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  warningContainer: {
    display: 'flex',
    gap: '1rem',
    '&[data-warn="true"]': {
      color: '#ffa000'
    },
    '&[data-error="true"]': {
      color: '#be1224'
    },
    transition: 'color 0.2s ease-in-out'
  }
}));
